<template>
  <div class="choose-person margin10 pct100 flex-layout">
    <el-input class="input-area"
              placeholder="请选择执行人员"
              readonly
              :disabled="disabled"
              v-model="searchList">
      <el-button slot="suffix"
                 type="text"
                 v-if="!disabled"
                 @click="openChoose">选择</el-button>
    </el-input>

    <el-dialog title="选择人员"
               :visible.sync="showPanel"
               v-dialogDrag
               width="1000px"
               :modal="false"
               class="dialog"
               @close="close">
      <div class="content"
           style="height: 480px">
        <el-form :inline="true">

          <el-form-item label="姓名">
            <el-input placeholder="请输入姓名"
                      clearable
                      v-model="filter.name"></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input placeholder="请输入工号"
                      clearable
                      v-model="filter.workNo"></el-input>
          </el-form-item>
          <el-form-item label="员工类型">
            <el-select v-model="filter.personOrAccountType"
                       clearable
                       @change="typeChange">
              <el-option v-for="item in personType"
                         :key="item.id"
                         :value="item.id"
                         :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="部门">
            <el-input clearable
                      placeholder="请选择部门"
                      @click.native="showTree = !showTree"
                      v-model="departmentNames"
                      @clear="handleClear"></el-input>
            <div class="tree-container"
                 v-show="showTree"
                 @mouseleave="showTree = false">
              <el-tree :data="departmentData"
                       ref="tree"
                       node-key="departmentCode"
                       :props="treeProps"
                       :renderContent="renderContent"
                       :filter-node-method="filterNode"
                       show-checkbox
                       @check="handleCheck">
              </el-tree>
            </div>
          </el-form-item> -->

          <el-button type="primary"
                     @click="getPersonList">查询</el-button>
          <el-button type="info"
                     @click="reset">重置</el-button>

        </el-form>
        <el-table :data="tableData"
                  height="400px"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" />
          <el-table-column prop="personOrAccountType"
                           label="类型">
            <template slot-scope="scope">
              <span>{{scope.row.personOrAccountType==1?'保卫':scope.row.personOrAccountType==2?'员工':''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="姓名" />
          <el-table-column prop="workNo"
                           label="工号" />
          <el-table-column prop="departmentName"
                           label="部门" />
          <el-table-column prop="position"
                           label="岗位" />
          <el-table-column prop="phone"
                           label="手机" />
        </el-table>
        <el-row class="tc"
                style="margin-top:10px">
          <el-pagination class="page-comp"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :page-size="page.pageSize"
                         :total="page.total"
                         :current-page="page.currentPage"
                         @size-change="sizeChange"
                         @current-change="pageChange"
                         @prev-click="pageChange"
                         @next-click="pageChange" />
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="info"
                   @click="close">取消</el-button>
        <el-button type="primary"
                   @click="submit">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: "choose-people",
  model: {
    prop: "selectPerson",
    event: "handleReturn",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selectPerson: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    selectPerson (newVal) {

      this.searchList = (newVal || [])
        .map((item) => {
          return item.nickName;
        })
        .join(",");
    },
  },
  data () {
    return {
      searchList: "",
      personType: [
        {
          id: 1,
          label: "保卫",
        },
        {
          id: 2,
          label: "员工",
        },
      ],
      //  弹窗数据
      showPanel: false,
      // 选中的人员名单
      selectedList: [],
      tableData: [],
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      filter: {
        name: "",
        personOrAccountType: '',
        workNo: "",
      },
    };
  },
  mounted () {
    this.getPersonList()
  },
  methods: {
    openChoose () {
      this.showPanel = true
    },
    // 列表勾选人员
    handleSelectionChange (value) {
      this.selectedList = value
    },
    // 取消弹窗
    close () {
      this.showPanel = false;
      // this.clearData()
    },
    typeChange () {
      this.getPersonList()
    },
    // 获取人员
    getPersonList () {
      let params = {
        // departmentCodeList: this.departmentCodeList,
        name: this.filter.name, // 员工或者保卫姓名
        workNo: this.filter.workNo, // 员工或者保卫姓名
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        personOrAccountType: this.filter.personOrAccountType,
      };
      this.$fetch(api.workOrder.queryPersonnelOrAccount, params).then(res => {
        if (res.success) {
          let list = res.returnObj.list
          if (list && list.length) {
            this.tableData = list;
            this.page.total = res.returnObj.total
          } else {
            this.tableData = []
          }
        } else {
          this.$message.error(res.msgContent);
        }
      })

    },
    submit () {
      let result = []
      this.searchList = this.selectedList.map(el => {
        result.push({
          accountNumber: el.workNo || el.personOrAccountCode,
          nickName: el.name,
          accountType: el.personOrAccountType
        })
        return el.name
      }).join(",")

      this.$emit("handleReturn", result);
      this.close()
    },
    // 重置
    reset () {
      this.clearData()
      this.getPersonList()
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.getPersonList()
    },
    pageChange (pageNo) {
      this.page.currentPage = pageNo;
      this.getPersonList()
    },
    clearData () {
      this.filter.name = ''
      this.filter.workNo = ''
      this.filter.personOrAccountType = ''
      this.page.pageSize = 10
      this.page.currentPage = 1
      this.page.total = 0
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-person {
  z-index: 99;
  position: relative;
  .input-area {
    flex: 1;
  }

  .list-area {
    margin-left: 10px;
    flex: 2;
  }

  .person-show {
    background-color: #262a49;
    // @include set_theme_color(background-color, dialog-main-bg-color);
    .title-text {
      background-color: #272b37;
      padding: 10px;
    }
    .body {
      background-color: #171c28;
    }
    .footer {
      padding: 5px;
      background-color: #272b37;
    }
    .person-list {
      overflow: hidden;
      height: 200px;
    }

    .person-item {
      @include set_theme_color(background-color, content-bg-color);

      &:nth-child(odd) {
        @include set_theme_color(background-color, menu-tab-bg-color);
      }

      &:hover {
        @include set_theme_color(background-color, item-active-bg-color);
      }
    }

    .person-choose-list {
      width: 100%;
    }

    .person-radio,
    .person-checkbox {
      width: 100%;
      padding: 8px 10px;
    }
  }

  .person-info-item {
    width: 50%;
  }

  .no-data-text {
    height: 100%;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>